import React, {Component} from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import api from '../../api';
import {BootstrapForm} from '../bootstrap/Form';
import { hasFeature } from '../../utils/featureFlags';

/**
 * The discount permission controls (OPE-112) are hidden until the shared
 * admin rollout flag is on: granting them is the normal UI path to the new
 * screens and APIs. Server-side feature checks stay independent of this.
 */
@connect(state => ({ discountsAdmin: hasFeature(state.auth.user, 'discountsAdmin') }))
export default class EditPermissionsModal extends Component {
		constructor(props){
            super(props);

            var permissions = {
                VIEW_REPORTS: false,
                CAN_ADD_DELETE_STAFF: false,
                MANAGE_PARTNERS: false,
                MANAGE_CREDIT: false,
                MANAGE_BILLING: false,
                LOGIN_AS_FERGUS_USER: false,
                VIEW_DISCOUNTS: false,
                MANAGE_DISCOUNTS: false
            };

            this.props.permissions.forEach(permission => {
                permissions[permission.name] = true;
            });

            this.state = {
                permissions: permissions,
                isSaving: false,
                error: false
            }
		}

        componentWillReceiveProps(nextProps) {
            this.setState({
                nextProps
            });
        }

		handleChange(e) {
			var permissions = this.state.permissions;
            permissions[e.target.name] = e.target.checked;

			this.setState({permissions});
		}

        handleSave(){
            this.handleSubmit(false);
        }

		handleSubmit(e) { 
            this.setState({isSaving: true, errors : {}});
            
            //Get active permissions (names only)
            var activePermissions = Object.keys(this.state.permissions).map(key => {
                return { 
                    name: key,
                    value: this.state.permissions[key]
                };
            }).filter(permission => {
                return permission.value === true;
            }).map(permission => {
                return permission.name
            });

            //api post
		    api.post(`users/${this.props.userId}/permissions`, {
                permissions: {
                    ...activePermissions
                },
                reset: true
            })
            .then(response => {
                this.props.closeModal();
                this.props.loadActiveUser();
            }).catch(error => {
                console.log("save permissions error");
                
                this.setState({
                    isSaving : false,
                    error : "Count not save the changes."
                });
            });
		}

		render() {
				var actionButton = this.state.isSaving ? 
				(<button className="btn btn-success disabled">Saving Permissions...</button>) :
				(<button className="btn btn-success" onClick={this.handleSave.bind(this)}>Save Permissions</button>);

				return (
						<Modal actionButton={actionButton} className="modal-success" title={"Edit Permissions"}>
								<BootstrapForm ref="form" onSubmit={this.handleSubmit.bind(this)} inputs={this.state.permissions} className="form-horizontal">                  
									<div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__viewReports" style={{height: "34px", lineHeight: "34px", float: "right"}}>View Reports</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__viewReports"
                                                 name='VIEW_REPORTS'
            									 className="form-control"
            									 onChange={this.handleChange.bind(this)}
            									 checked={this.state.permissions.VIEW_REPORTS}
                                            />
                                        </div>
									</div>

                                    <br />

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__canAddDeleteStaff" style={{height: "34px", lineHeight: "34px", float: "right"}}>Can Add/Delete Staff</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__canAddDeleteStaff"
                                                 name='CAN_ADD_DELETE_STAFF'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.CAN_ADD_DELETE_STAFF}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__managePartners" style={{height: "34px", lineHeight: "34px", float: "right"}}>Manage Partners</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__managePartners"
                                                 name='MANAGE_PARTNERS'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.MANAGE_PARTNERS}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__manageCredit" style={{height: "34px", lineHeight: "34px", float: "right"}}>Manage Credit</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__manageCredit"
                                                 name='MANAGE_CREDIT'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.MANAGE_CREDIT}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__manageBilling" style={{height: "34px", lineHeight: "34px", float: "right"}}>Manage Billing</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__manageBilling"
                                                 name='MANAGE_BILLING'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.MANAGE_BILLING}
                                            />
                                        </div>
                                    </div>

                                    {this.props.discountsAdmin &&
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__viewDiscounts" style={{height: "34px", lineHeight: "34px", float: "right"}}>View Discounts</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__viewDiscounts"
                                                 name='VIEW_DISCOUNTS'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.VIEW_DISCOUNTS}
                                            />
                                        </div>
                                    </div>
                                    }

                                    {this.props.discountsAdmin &&
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__manageDiscounts" style={{height: "34px", lineHeight: "34px", float: "right"}}>Manage Discounts</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__manageDiscounts"
                                                 name='MANAGE_DISCOUNTS'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.MANAGE_DISCOUNTS}
                                            />
                                        </div>
                                    </div>
                                    }

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label htmlFor="input__loginAsFergusUser" style={{height: "34px", lineHeight: "34px", float: "right"}}>Login As Fergus User</label>
                                        </div>
                                        <div className="col-sm-5 col-sm-offset-1">
                                            <input type="checkbox"
                                                 id="input__loginAsFergusUser"
                                                 name='LOGIN_AS_FERGUS_USER'
                                                 className="form-control"
                                                 onChange={this.handleChange.bind(this)}
                                                 checked={this.state.permissions.LOGIN_AS_FERGUS_USER}
                                            />
                                        </div>
                                    </div>
							</BootstrapForm>
						</Modal>
				);
		}
}



// WEBPACK FOOTER //
// ./app/components/modal/EditPermissionsModal.js